import { InventoryActionTypes } from './constants';

const GET_PROFIT_LOSS_DATA_INITIAL_STATE = {
    ProfitLossData: [],
    loading: false,
};

const GET_INVENTORY_DATA_INITIAL_STATE = {
    InventoryData: [],
    loading: false,
};
const UPDATE_INVENTORY_DATA_INITIAL_STATE = {
    updateInventory: null,
    loading: false,
    error: null,
};

const InventoryDataReducer = (state = GET_INVENTORY_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InventoryActionTypes.INVENTORY_DATA_LOADING:
            return {
                InventoryData: state.InventoryData,
                loading: true,
            };
        case InventoryActionTypes.INVENTORY_DATA_SUCCESS:
            return {
                InventoryData: action.payload,
                loading: false,
            };
        case InventoryActionTypes.INVENTORY_DATA_ERROR:
            return {
                InventoryData: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};

const updateInventoryReducer = (state = UPDATE_INVENTORY_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InventoryActionTypes.UPDATE_INVENTORY_DATA_LOADING:
            return {
                ...state,
                loading: true,
            };
        case InventoryActionTypes.UPDATE_INVENTORY_DATA_SUCCESS:
            return {
                updateInbound: action.payload,
                loading: false,
            };
        case InventoryActionTypes.UPDATE_INVENTORY_DATA_ERROR:
            return {
                updateInbound: action.payload,
                // error: action.payload,
                loading: false,
            };
        case InventoryActionTypes.UPDATE_INVENTORY_DATA_RESET:
            return UPDATE_INVENTORY_DATA_INITIAL_STATE;
        default:
            return state;
    }
};

const ProfitLossDataReducer = (state = GET_PROFIT_LOSS_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InventoryActionTypes.PROFIT_LOSS_DATA_LOADING:
            return {
                ProfitLossData: state.ProfitLossData,
                loading: true,
            };
        case InventoryActionTypes.PROFIT_LOSS_DATA_SUCCESS:
            return {
                ProfitLossData: action.payload,
                loading: false,
            };
        case InventoryActionTypes.PROFIT_LOSS_DATA_ERROR:
            return {
                ProfitLossData: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};

export {InventoryDataReducer,updateInventoryReducer, ProfitLossDataReducer };
